<ion-content
  class="simple-spinner-modal_content"
  [ngClass]="
    (platformService?.isTouchExperience$ | async)
      ? platformService?.platformType === platformService?.platformEnum?.tablet
        ? 'ion-content-modal-tablet'
        : 'ion-content-modal-mobile'
      : 'ion-content-modal-desktop'
  "
>
  <div class="content">
    <ion-spinner [name]="spinnerType" data-cy="ion-spinner-icon"></ion-spinner>
  </div>
</ion-content>
